// extracted by mini-css-extract-plugin
export var labelWrapper = "_i9-0";